export const SummmaryDashboardColumnHeaders = {
  stops: $localize`Stops`.toUpperCase(),
  volume: $localize`Volume`.toUpperCase(),
  delivery: $localize`Delivery`.toUpperCase(),
  total: $localize`Total`.toUpperCase(),
  completed: $localize`Completed`.toUpperCase(),
  pending: $localize`Pending`.toUpperCase(),
  pickups: $localize`Pickups`.toUpperCase(),
};
